import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { helpers } from "@shop/frontend/web/js/helpers";

import { orderHelper } from "../../helpers/OrderHelper";

export class EventOrderView {
	constructor() {
		this.$eventSum = $("#js-event-sum");
		this.$ticketsItems = $("#js-tickets-items");

		this.$placesBuy = $("#js-places-buy");
		this.$tickets = $(".js-tickets");

		this.ticketTemplate = $("#js-ticket-template")[0];
	}

	/**
	 * Рендерит заказ мероприятия
	 * @param order {Object} - Модель заказа
	 */
	render(order) {
		this.$eventSum.text(order.amount);

		this.$ticketsItems.html("");
		$.each(order.carts, (i, cart) => {
			let sector = cart.sector || cart.view_id;
			if (sector) {
				sector =
					!cart.is_pack && !cart.hide
						? translator.t("main", "Sector") + " " + sector
						: cart.priceObject
						? cart.priceObject.price_view_name
						: sector;
			}

			cart.name = `${translator.t("main", "Row")} ${cart.row} ${translator.t(
				"main",
				"place"
			)} ${cart.col}`;

			this.$ticketsItems.append(
				orderHelper.insertDataToTicket(
					$(document.importNode(this.ticketTemplate.content, true)),
					{
						...cart,
						sector,
						order_id: order.id,
						allowedLoyaltyCategories: window.allowedLoyaltyCategories,
					}
				)
			);
			$(".price-category-select").ariaDropdown();
		});

		this.renderCount(order.carts.length);
	}

	renderCount(count) {
		$(".js-count-event").text(count);
		$(".js-count-word").text(
			helpers.wordEnding(count, [
				translator.t("event", "ticket"),
				translator.t("event", "tickets"),
				translator.t("event", "tickets "),
			])
		);
	}
}
